<template>
  <div class="content_usersetting mg_bot50 clearfix" id="user_trading_settings">
    <div class="filter_container clearfix">
      <!-- Select Markets -->
      <div class="clearfix col-xs-4 market-select-area">
        <span class="title_item select-market-text">
          {{ $t("circuit_breaker_setting.select_market") }}
        </span>
        <select-box
          v-model="currency"
          class="select-market"
          :options="markets"
        />
      </div>

      <div class="search_box form-group col-xs-6">
        <input
          type="text"
          placeholder="Search"
          v-on:keyup.enter="search"
          @keyup="debounceSearch"
          class="form-control search_input"
          name="searchKey"
          v-model="searchKey"
        />
      </div>

      <div class="clearfix"></div>
    </div>

    <div class="row">
      <div class="col-xs-6 col-sm-5 col-left-user">
        <div class="box_table_UserSetting_right">
          <table
            class="table table_UserSetting_right"
            :class="balancesDefault ? 'table_hover' : ''"
            :limit="10"
            :column="8"
          >
            <thead>
              <tr>
                <th class="text-left">{{ $t("enable_trading.no") }}</th>
                <!-- <th class="text-left" >{{ $t('enable_trading.currency') }}</th> -->
                <th class="text-left">{{ $t("enable_trading.coin") }}</th>
                <th class="text-left">{{ $t("enable_trading.title") }}</th>
                <!-- <th class="text-left">{{ $t('enable_trading.show_beta_tester') }}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, key) in coinList"
                :key="key"
                @click="getDataUserTable(item)"
                :class="{
                  active:
                    item.currency == selectedCoinPair.currency &&
                    item.coin == selectedCoinPair.coin,
                }"
              >
                <td class="text-left">
                  <div class="text-bold-coin">{{ key + 1 }}</div>
                </td>
                <!-- <td class="text-left">
                <div class="item_email_setting font14">
                  {{ (item.currency || '--') | uppercase }}
                </div>
              </td> -->
                <td class="text-left">
                  {{ (item.coin || "--") | uppercase }}
                </td>
                <td class="text-left">
                  <BaseButton
                    class="common-btn-item"
                    :color="item.is_enable ? 'green' : 'red'"
                    size="small"
                    @click.stop="onClickedUpdateCoinSetting(item)"
                  >
                    {{
                      item.is_enable
                        ? $t("common.action.enable")
                        : $t("common.action.disable")
                    }}
                  </BaseButton>
                </td>
                <!-- <td class="text-left">
                <button :disabled="item.is_enable == 1" class="btn"
                  :class="item.is_show_beta_tester ? 'btn_enable' : 'btn_disable'"
                  @click.stop="onClickedUpdateShowBetaTester(item)">
                  {{ item.is_show_beta_tester ? $t('common.action.enable') : $t('common.action.disable') }}
                </button>
              </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-xs-6 col-sm-7 col-right-user">
        <div class="datatable box_UserSetting_right">
          <data-table
            :getData="getData"
            :totalUser="numberOfUser"
            ref="datatable"
            :limit="10"
            :column="5"
            class="scroll height-custom"
          >
            <th class="text-left cl_170" data-sort-field="email">
              {{ $t("user.email") }}
            </th>
            <!-- <th class="text-left cl_120">{{ $t('enable_trading.currency') }}</th> -->
            <th class="text-left cl_80">{{ $t("enable_trading.coin") }}</th>
            <!-- <th class="text-left cl_120">{{ $t('enable_trading.is_beta_tester') }}</th> -->
            <th class="text-left cl_110">
              {{ $t("enable_trading.status") }}
            </th>
            <th class="text-center cl_170">
              <BaseButton
                @click="addAccount()"
                :disabled="!selectedCoinPair.currency || !selectedCoinPair.coin"
                size="small"
              >
                <i class="icon-plus"></i>
                {{ $t("account_setting.add_account") }}
              </BaseButton>
            </th>

            <template slot="body" slot-scope="props">
              <tr
                v-bind:class="{ inactive: props.item.status === 'inactive' }"
                v-if="props.item.enable_trading != 'ignore'"
              >
                <td class="text-left font14">
                  <div
                    class="item_email_setting font14"
                    @mouseenter="handleEmailHover"
                  >
                    <span class="txt_email_setting font14">{{
                      props.item.email
                    }}</span>
                    <span class="tooltip_email_setting font14">{{
                      props.item.email
                    }}</span>
                  </div>
                </td>
                <!-- <td class="text-left font14">{{ props.item.currency | uppercase }}</td> -->
                <td class="text-left font14">
                  {{ props.item.coin | uppercase }}
                </td>
                <!-- <td class="text-left font14">{{ props.item.is_beta_tester ? $t('common.action.yes') : $t('common.action.no') }}</td> -->
                <td class="text-left cl_170">
                  <BaseButton
                    class="common-btn-item"
                    :color="
                      props.item && props.item.enable_trading == 'enable'
                        ? 'green'
                        : 'red'
                    "
                    size="small"
                    @click.stop="onClickedUpdateUserSetting(props.item)"
                  >
                    {{ convertStatus(props.item.enable_trading) }}
                  </BaseButton>
                  <!-- <span class="" :class="props.item.enable_trading ? 'status-enabled' : 'status-disabled'">
                    {{ props.item.enable_trading ? $t('common.action.enable') : $t('common.action.disable') }}
                  </span> -->
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-close-table"
                    @click="confirmDeleteColumn(props.item)"
                  >
                    <i class="icon-close2"></i>
                  </button>
                </td>
              </tr>
            </template>
          </data-table>
        </div>
      </div>

      <modal name="addUserEnableFee" width="450" :disabled="checkDisableBtn">
        <div slot="body" class="body-popup add-user-enable-fee">
          <div class="form-group-detail">
            <div class="group-detail-form-group">
              <label class="group-detail-form-label">{{
                $t("airdrop_setting.email")
              }}</label>
              <input
                class="group-detail-form-value"
                maxlength="190"
                id="input-airdrop-title"
                type="email"
                :name="'email'"
                v-model.trim="newUser.email"
                :placeholder="$t('airdrop_setting.email')"
                data-vv-validate-on="none"
                @focus="resetErrors"
                @input="handleEmailInput"
                :data-vv-as="$t('airdrop_setting.email1')"
                v-validate="'required|email'"
                v-bind:class="{ 'error-modal': errors.has('email') }"
              />
              <div class="clearifx"></div>
              <div class="error-box">
                <span v-show="errors.has('email')" class="f-left is-error">{{
                  errors.first("email")
                }}</span>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  v-model="newUser.inThisMarket"
                  @change="checkedCreateNewUser($event, 'inThisMarket')"
                  id="inThisMarket"
                />
                <label class="form-check-label" for="inThisMarket">{{
                  $t("enable_trading.this_market")
                }}</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  v-model="newUser.allMarket"
                  @change="checkedCreateNewUser($event, 'allMarket')"
                  id="allMarket"
                />
                <label class="form-check-label" for="allMarket">
                  {{ $t("enable_trading.all_market") }}</label
                >
              </div>
            </div>

            <!--<div class="group-detail-form-group">-->
            <!--<label class="group-detail-form-label">{{ $t('airdrop_setting.lock_period') }}</label>-->
            <!--<currency-input class="group-detail-form-value" :value="newUser.period" v-model="newUser.period" v-bind:class="{ 'error-modal': errors.has('period') }"/>-->
            <!--<div class="clearifx"></div>-->
            <!--<div class="error-box">-->
            <!--<span v-show="errors.has('period')" class="f-left is-error">{{ errors.first('period') }}</span>-->
            <!--</div>-->
            <!--</div>-->

            <!--<div class="group-detail-form-group">-->
            <!--<label class="group-detail-form-label">{{ $t('airdrop_setting.unlock_percent_period') }}</label>-->
            <!--<currency-input :precision='2' class="group-detail-form-value" :value="newUser.unlock_percent" v-model="newUser.unlock_percent" v-bind:class="{ 'error-modal': errors.has('unlock_percent') }"/>-->
            <!--<div class="clearifx"></div>-->
            <!--<div class="error-box">-->
            <!--<span v-show="errors.has('unlock_percent')" class="f-left is-error">{{ errors.first('unlock_percent') }}</span>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
      </modal>

      <modal
        name="deleteUserEnableFee"
        width="450"
        :disabled="disableBtnRemove"
      >
        <div slot="body" class="body-popup add-user-enable-fee">
          <div class="form-group-detail">
            <div class="group-detail-form-group">
              <label class="group-detail-form-label-1">{{
                $t("airdrop_setting.confirm_remove")
              }}</label>
              <div class="form-check">
                <input
                  type="checkbox"
                  v-model="deletingUser.inThisMarket"
                  @change="checkedDeleteUser('inThisMarket')"
                  id="inThisMarket"
                />
                <label class="form-check-label" for="inThisMarket">{{
                  $t("enable_trading.remove_this_market")
                }}</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  v-model="deletingUser.allMarket"
                  @change="checkedDeleteUser('allMarket')"
                  id="allMarket"
                />
                <label class="form-check-label" for="allMarket">
                  {{ $t("enable_trading.remove_all_market") }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
    <loading-modal />
  </div>
</template>

<script>
import rf from "../../lib/RequestFactory";
import Numeral from "../../lib/numeral";
import SelectBox from "../../components/SelectBox";
import Modal from "../../components/Modal";
import { Validator } from "vee-validate";

import BaseButton from "../../common/Button.vue";
import LoadingModal from "@/modals/common/LoadingModal.vue";
export default {
  components: {
    SelectBox,
    Modal,
    BaseButton,
    LoadingModal,
  },
  data() {
    return {
      titlePage: this.$t("enable_trading.title"),
      searchKey: "",
      balances: [],
      balancesDefault: false,
      numberOfUser: 0,
      isChosen: false,
      markets: [],
      currency: { id: "btc", name: "BTC" },
      coinList: [],
      selectedCoinPair: {},
      hasError: false,
      showErrorModal: false,
      newUser: {},
      deletingUser: {
        allMarket: false,
        inThisMarket: false,
      },
      checkDisableBtn: true,
      deletingInProgress: false,
    };
  },
  watch: {
    currency(newValue) {
      this.$refs.datatable?.$emit("DataTable:filter", {});
      this.getDataCoinList(newValue);
    },
  },
  computed: {
    disableBtnRemove() {
      return (
        this.deletingInProgress ||
        !(this.deletingUser.allMarket || this.deletingUser.inThisMarket)
      );
    },
  },
  methods: {
    handleEmailHover(event) {
      const emailContainer = event.currentTarget;
      const emailText = emailContainer.querySelector(".txt_email_setting");
      const tooltip = emailContainer.querySelector(".tooltip_email_setting");

      if (emailText && tooltip) {
        // Check if text is truncated by comparing scrollWidth with clientWidth
        const isTruncated = emailText.scrollWidth > emailText.clientWidth;

        // Hide tooltip if text is not truncated
        if (!isTruncated) {
          tooltip.style.display = "none";
        } else {
          tooltip.style.display = "";
        }
      }
    },
    handleEmailInput(event) {
      const input = event.target;
      if (input && input.scrollWidth > input.clientWidth) {
        input.scrollLeft = input.scrollWidth;
      }
    },
    convertStatus(item) {
      if (item == "enable") {
        return window.i18n.t("common.action.enable");
      } else if (item == "disable") {
        return window.i18n.t("common.action.disable");
      } else if (item == "waiting") {
        return window.i18n.t("common.action.waiting");
      } else {
        return "";
      }
    },
    trimNumber(number) {
      if (!number) return null;
      let zeroValue = "0";
      let numberOfDecimalDigits = 10;
      let format =
        numberOfDecimalDigits == 0
          ? "0,0"
          : "0,0.[" + Array(numberOfDecimalDigits + 1).join("0") + "]";
      if (window._.isNil(zeroValue)) {
        zeroValue = "";
      }
      return Numeral(number).format(format);
    },
    showModal(config) {
      const type = config.type;
      const title = config.title;
      const content = config.content;
      const customContent = config.customContent;

      let btnCancelLabel = config.btnCancelLabel || this.$t("common.action.no");
      let btnConfirmLabel =
        config.btnConfirmLabel || this.$t("common.action.yes");
      if (config.noAction) {
        btnCancelLabel = null;
        btnConfirmLabel = null;
      }
      const onConfirm = config.onConfirm;
      const onCancel = config.onCancel;

      window.ConfirmationModal.show({
        type: type,
        title: title,
        content: content,
        customContent: customContent,
        btnCancelLabel: btnCancelLabel,
        btnConfirmLabel: btnConfirmLabel,
        onConfirm: onConfirm,
        onCancel: onCancel,
      });
    },

    search() {
      this.searchKey = this.searchKey.trim();
      this.$refs.datatable?.$emit("DataTable:filter", {
        currency: this.selectedCoinPair.currency,
        coin: this.selectedCoinPair.coin,
        search_key: this.searchKey,
      });
    },
    debounceSearch: _.debounce(function () {
      this.searchKey = this.searchKey.trim();
      this.$refs.datatable?.$emit("DataTable:filter", {
        currency: this.selectedCoinPair.currency,
        coin: this.selectedCoinPair.coin,
        search_key: this.searchKey,
      });
    }, 1500),

    getData(params) {
      if (params.search_key) {
        return this.getUserListFromCoinPair(params);
      }

      if (params.currency && params.coin) {
        return this.getUserListFromCoinPair(params);
      }

      return this.resetDataUserTable();
    },

    getDataUserTable(params) {
      this.$refs.datatable?.$emit("DataTable:filter", params);
      this.search_key = "";
    },

    resetDataUserTable() {
      return new Promise((resolve, reject) => {
        return resolve({ data: [] });
      });
    },

    getUserListFromCoinPair(setting) {
      let currency = setting.currency;
      let coin = setting.coin;
      this.selectedCoinPair = {
        currency: currency,
        coin: coin,
      };

      this.$modal.show("modal-loading");
      let res = rf
        .getRequest("AdminRequest")
        .getUserEnableTradingSetting(setting)
        .then((res) => {
          if (!res.data || !res.data.data) return res;

          window._.map(res.data.data, (currenItem) => {
            currenItem.currency = setting.currency;
            currenItem.coin = setting.coin;
            currenItem.isWrite = false;
            currenItem.isReset = false;
          });

          return res;
        })
        .finally(() => {
          this.$modal.hide("modal-loading");
        });

      return res;
    },

    getDataCoinList(params) {
      let newParams = {
        ...params,
        currency: this.currency.id,
      };
      this.$modal.show("modal-loading");
      return rf
        .getRequest("AdminRequest")
        .getEnableTradingSetting(newParams)
        .then((res) => {
          let newCoinList = [];
          if (res.data) {
            newCoinList = res.data;
          }
          this.coinList = newCoinList;
          this.resetDataUserTable();
        })
        .finally(() => {
          this.$modal.hide("modal-loading");
        });
    },

    addAccount() {
      this.errors.clear();
      this.newUser = {};
      this.checkDisableBtn = true;

      CommonModal.show("addUserEnableFee", {
        position: "add-group customModal",
        mask: true,
        buttons: [
          {
            label: this.$t("common.action.cancel"),
            focused: true,
            style: {
              width: "140px",
              background: "rgb(0, 112, 192)",
            },
            callback: () => {
              this.newUser = {};
              this.checkDisableBtn = true;
              CommonModal.hide("addUserEnableFee");
            },
          },
          {
            label: this.$t("common.action.save"),
            focused: true,
            style: {
              width: "140px",
              background: "rgb(0, 112, 192)",
            },
            isDisableBtn: true,
            callback: () => {
              let item = this.newUser;
              this.createNewUser(item);
            },
          },
        ],
      });
    },

    checkedCreateNewUser(e, type) {
      if (type == "inThisMarket") {
        this.newUser.allMarket = false;
        this.checkDisableBtn = e.target.checked ? false : true;
      } else if (type == "allMarket") {
        this.newUser.inThisMarket = false;
        this.checkDisableBtn = e.target.checked ? false : true;
      }
    },

    async createNewUser(item) {
      this.errors.clear();
      let isValid = await this.validateModal();
      this.showErrorModal = false;
      if (!isValid) {
        this.showErrorModal = true;
        return;
      }

      let params = {
        email: item.email,
        coin: this.selectedCoinPair.coin,
        currency: this.selectedCoinPair.currency,
        inThisMarket: item.inThisMarket,
        allMarket: item.allMarket,
      };
      this.$modal.show("modal-loading");
      this.checkDisableBtn = true;
      rf.getRequest("AdminRequest")
        .createUserEnableTradingSetting(params)
        .then((res) => {
          CommonModal.hide("addUserEnableFee");
          this.$toastr("success", window.i18n.t("common.alert.create.success"));
          this.newUser = {};
          this.search();
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.message) {
            this.errors.add({ field: "email", msg: e.response.data.message });
          }
        })
        .finally(() => {
          this.$modal.hide("modal-loading");
          this.checkDisableBtn = !(this.newUser.inThisMarket || this.newUser.allMarket);
        });
    },

    async validateModal() {
      this.errors.clear();
      await this.$validator.validate("email");

      if (this.errors.count() > 0) {
        return false;
      }
      return true;
    },

    checkedDeleteUser(type) {
      if (type == "inThisMarket") {
        this.deletingUser.allMarket = false;
      } else if (type == "allMarket") {
        this.deletingUser.inThisMarket = false;
      }
    },

    confirmDeleteColumn(item) {
      this.deletingUser = {
        allMarket: false,
        inThisMarket: false,
      };

      CommonModal.show("deleteUserEnableFee", {
        position: "add-group customModal",
        mask: true,
        buttons: [
          {
            label: this.$t("common.action.no"),
            focused: true,
            style: {
              width: "140px",
              background: "rgb(0, 112, 192)",
            },
            callback: () => {
              this.deletingUser = {
                allMarket: false,
                inThisMarket: false,
              };
              CommonModal.hide("deleteUserEnableFee");
            },
          },
          {
            label: this.$t("common.action.yes"),
            focused: true,
            style: {
              width: "140px",
              background: "rgb(0, 112, 192)",
            },
            isDisableBtn: true,
            callback: () => {
              this.deleteColumn(item);
            },
          },
        ],
      });
    },

    deleteColumn(item) {
      if (this.itemUser && item.user_id == this.itemUser.user_id) {
        this.itemUser = null;
        this.currentUser = false;
      }
      let params = {
        ...item,
        inThisMarket: this.deletingUser.inThisMarket,
        allMarket: this.deletingUser.allMarket,
      };
      this.$modal.show("modal-loading");
      this.deletingInProgress = true;
      rf.getRequest("AdminRequest")
        .deleteUserEnableTradingSetting(params)
        .then((res) => {
          this.search();
          this.$toastr(
            "success",
            window.i18n.t("enable_trading.remove_success")
          );
          this.deletingUser = {
            allMarket: false,
            inThisMarket: false,
          };
          CommonModal.hide("deleteUserEnableFee");
        })
        .catch((ex) => {
          this.$toastr("error", window.i18n.t("enable_trading.remove_fail"));
        })
        .finally(() => {
          this.$modal.hide("modal-loading");
          this.deletingInProgress = false;
        });
    },

    onClickedUpdateUserSetting(setting) {
      const title =
        setting && setting.enable_trading == "enable"
          ? this.$t("enable_trading.user_setting.confirm_off")
          : this.$t("enable_trading.user_setting.confirm_on");
      let params = {
        ...setting,
        enable_trading:
          setting.enable_trading == "enable" ? "disable" : "enable",
      };

      this.showModal({
        type: "confirm",
        title: title,
        onConfirm: () => {
          this.$modal.show("modal-loading");
          rf.getRequest("AdminRequest")
            .updateUserEnableTradingSetting(params)
            .then((res) => {
              setting.enable_trading =
                setting.enable_trading == "enable" ? "disable" : "enable";
              setting.is_beta_tester = res.data.is_beta_tester;
              if (setting.enable_trading === "enable") {
                this.$toastr(
                  "success",
                  window.i18n.t("enable_trading.user_setting.update_success")
                );
              } else {
                this.$toastr(
                  "success",
                  window.i18n.t("enable_trading.user_setting.update_success2")
                );
              }
            })
            .catch((e) => {
              this.$toastr(
                "error",
                window.i18n.t("enable_trading.user_setting.update_fail")
              );
            })
            .finally(() => {
              this.$modal.hide("modal-loading");
            });
        },
      });
    },

    onClickedUpdateCoinSetting(setting) {
      const title =
        setting && setting.is_enable
          ? this.$t("enable_trading.user_setting.confirm_off")
          : this.$t("enable_trading.user_setting.confirm_on");
      let params = {
        ...setting,
        is_enable: !setting.is_enable,
      };

      this.showModal({
        type: "confirm",
        title: title,
        onConfirm: () => {
          this.$modal.show("modal-loading");
          rf.getRequest("AdminRequest")
            .updateEnableCoinSetting(params)
            .then((res) => {
              setting.is_enable = !setting.is_enable;
              if (setting.is_enable) {
                setting.is_show_beta_tester = false;
                this.$toastr(
                  "success",
                  window.i18n.t("enable_trading.user_setting.update_success")
                );
              } else {
                this.$toastr(
                  "success",
                  window.i18n.t("enable_trading.user_setting.update_success2")
                );
              }
            })
            .catch((e) => {
              this.$toastr(
                "error",
                window.i18n.t("enable_trading.user_setting.update_fail")
              );
            })
            .finally(() => {
              this.$modal.hide("modal-loading");
            });
        },
      });
    },

    onClickedUpdateShowBetaTester(setting) {
      const title =
        setting && setting.is_show_beta_tester
          ? this.$t("enable_trading.user_setting.confirm_off")
          : this.$t("enable_trading.user_setting.confirm_on");
      let params = {
        ...setting,
        is_show_beta_tester: !setting.is_show_beta_tester,
      };

      this.showModal({
        type: "confirm",
        title: title,
        onConfirm: () => {
          this.$modal.show("modal-loading");
          rf.getRequest("AdminRequest")
            .updateEnableCoinSetting(params)
            .then((res) => {
              setting.is_show_beta_tester = !setting.is_show_beta_tester;
              this.$toastr(
                "success",
                window.i18n.t("enable_trading.user_setting.update_success")
              );
            })
            .catch((e) => {
              this.$toastr(
                "error",
                window.i18n.t("enable_trading.user_setting.update_fail")
              );
            })
            .finally(() => {
              this.$modal.hide("modal-loading");
            });
        },
      });
    },

    initEmptyList() {
      let i = 0;
      this.coinList = [];
      while (i++ < 10) {
        this.coinList.push({});
      }
    },
    // blockTabBrowser(e){
    //   if (e.key == 'Tab') {
    //     e.preventDefault();
    //   }
    // },
    loadMarkets() {
      this.$modal.show("modal-loading");
      rf.getRequest("AdminRequest")
        .getPriceGroupCurrency()
        .then((data) => {
          try {
            window._.map(data, (item) => {
              if (
                typeof item.currency !== "undefined" &&
                item.currency !== "usd"
              ) {
                this.markets.push({
                  id: item.currency,
                  name: item.currency.toUpperCase(),
                });
              }
            });
          } catch (ex) {
            console.error(ex);
          }
        })
        .finally(() => {
          this.$modal.hide("modal-loading");
        });
    },
  },
  created() {
    // document.addEventListener('keydown', this.blockTabBrowser);
    this.loadMarkets();
    this.getDataCoinList({});
  },
  beforeDestroy() {
    // document.removeEventListener('keydown',this.   blockTabBrowser);
  },
  mounted() {
    Validator.localize("en", {
      messages: {
        required: () => this.$t("errors.email_required"),
      },
    });
    this.$emit("EVENT_PAGE_CHANGE", this);
  },
};
</script>
<!--<style lang="scss">-->
<!--.height-custom{-->
<!--height: 100%;-->
<!--width: 100%;-->
<!--// overflow: hidden;-->
<!--table{-->
<!--// height : 445px;-->
<!--// max-height: 445px;-->
<!--}-->
<!--}-->
<!--.height-custom table{-->
<!--width: 100%;-->
<!--height: 100%;-->
<!--overflow-y: hidden;-->
<!--padding-right: 17px;-->
<!--box-sizing: content-box;-->
<!--}-->
<!--.th-last{-->
<!--padding: 0 !important;-->
<!--}-->
<!--</style>-->
<style lang="scss" scoped>
@import "@/assets/sass/variables";
.cl_address {
  width: 350px;
}
.cl_50 {
  width: 50px;
}
.cl_80 {
  width: 80px;
}
.cl_110 {
  width: 110px;
}
.cl_120 {
  max-width: 140px;
}
.cl_140 {
  max-width: 140px;
}
.cl_170 {
  max-width: 170px;
}
.font14 {
  font-size: $font-root !important;
}
.status-enabled {
  color: $color-jungle-green;
}
.status-disabled {
  color: $color_alizarin_crimson;
}
.content_modal_withdrawSetting {
  color: $color_mine_shaft;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  line-height: $font_big_24;
}
.form-check {
  margin-top: 10px;
  & input {
    margin-right: 4px;
  }
}
.form-check-label {
  color: #666666;
  font-weight: normal;
  font-family: $mulish-regular;
}

.content_usersetting {
  .icon-plus {
    color: #ffffff;
    margin-right: 5px;
  }
  .btn_enable {
    background-color: transparent;
    text-transform: uppercase;
    width: 70px;
    height: 25px;
    line-height: 20px;
    padding: 0px 0px;
    text-align: center;
    font-size: $font-smaller;
    font-weight: 600;
    color: $color-caribbean-green;
    border: 1px solid $color-caribbean-green;
    border-radius: 3px;
    transition: 0.5s;
    &:hover {
      background-color: $color-aquamarine;
      border-color: $color-aquamarine;
      color: $color_white;
      transition: 0.5s;
    }
  }
  .btn_disable {
    background-color: transparent;
    text-transform: uppercase;
    width: 70px;
    height: 25px;
    line-height: 20px;
    padding: 0px 0px;
    text-align: center;
    font-size: $font-smaller;
    font-weight: 600;
    color: $color_alizarin_crimson;
    border: 1px solid $color_alizarin_crimson;
    border-radius: 3px;
    transition: 0.5s;
    &:hover {
      background-color: $color_alizarin_crimson;
      border-color: $color_alizarin_crimson;
      color: $color_white;
      transition: 0.5s;
    }
  }
  .btn_view {
    float: right;
    background-color: $color-caribbean-green;
    text-transform: uppercase;
    width: 55px;
    height: 25px;
    line-height: 20px;
    padding: 0px 9px;
    text-align: center;
    font-size: $font-smaller;
    font-weight: 600;
    color: $color-white;
    border: 1px solid $color-caribbean-green;
    border-radius: 3px;
    transition: 0.5s;
    &:hover {
      background-color: $color-aquamarine;
      border-color: $color-aquamarine;
      color: $color_white;
      transition: 0.5s;
    }
  }

  .filter_container {
    margin: 7px 0px 15px 0px;

    .title_item {
      color: $color-grey-dark;
      font-size: $font_root;
      font-family: $mulish-regular;
      font-weight: 500;
      line-height: 30px;
      float: left;
      margin-right: 11px;
    }
    .search_box {
      padding-right: 0px;
      display: inline-block;
      float: right;
      width: 215px;
      max-width: 100%;
      margin-bottom: 0px;
      color: $color-grey-dusty;
      font-family: $mulish-regular;
      .search_input {
        background-color: transparent;
        height: 28px;
        border: 1px solid $color_alto;
        padding: 4px 15px;
        line-height: 20px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: $font-small;
      }
    }
  }
  .btn_detail_user {
    float: right;
    background-color: transparent;
    text-transform: uppercase;
    width: 65px;
    height: 23px;
    line-height: 20px;
    padding: 0px 9px;
    text-align: center;
    font-size: $font-smaller;
    font-weight: 600;
    color: $color-jungle-green;
    border: 1px solid $color-caribbean-green;
    border-radius: 20px;
    margin-left: 15px;
    transition: 0.5s;
    &:hover {
      background-color: $color_corn;
      border-color: $color_corn;
      color: $color_white;
      transition: 0.5s;
    }
  }

  .item_email_setting {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    .txt_email_setting {
      display: block;
      min-width: 130px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-transform: lowercase;
    }
    .tooltip_email_setting,
    .tooltip_address_setting {
      position: absolute;
      top: 0px;
      line-height: 20px;
      padding: 5px 20px;
      left: 100%;
      background-color: $color_white;
      white-space: nowrap;
      width: auto;
      z-index: 10;
      font-size: $font-smaller;
      font-weight: 500;
      color: $color_mine_shaft;
      transition: 0.5s;
      display: none;
      box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
      &:after {
        right: 100%;
        top: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-right-color: $color_white;
        border-width: 5px;
        margin-top: -5px;
      }
    }
    &:hover {
      .tooltip_email_setting,
      .tooltip_address_setting {
        display: block;
        transition: 0.5s;
      }
    }
    .tooltip_address_setting {
      top: 100%;
      left: 0;
      &:after {
        left: 25%;
        bottom: 100%;
        top: initial;
        border-bottom-color: $color_white;
        border-right-color: transparent;
      }
    }
  }
}

@media only screen and (min-width: 1399px) {
  .content_usersetting .item_email_setting .txt_email_setting {
    max-width: 250px;
  }
}

.box_table_UserSetting_right {
  min-height: 439px;
  background-color: $color_white;
  // max-height: 440px;
  overflow-y: auto;
  overflow-x: auto;
}
.box_UserSetting_right {
  // min-height: 440px;
  // background-color: $color_white;
}
.detail_balance {
  text-overflow: ellipsis;
  width: 150px;
  overflow: hidden;
  vertical-align: middle;
}
.detail_available_balance {
  text-overflow: ellipsis;
  width: 180px;
  overflow: hidden;
  vertical-align: middle;
}

.add-user-enable-fee {
  .is-error {
    color: $color_red_text !important;
  }
  .error-box {
    display: block;
    float: left;
    overflow: hidden;
    width: 100%;
    span {
      font-family: $mulish-regular !important;
    }
  }
}

.btn-add {
  height: 22px;
  border-radius: 3px;
  background-color: #b7ff03;
  border: 1px solid #b7ff03;
  font-size: $font_mini_mini;
  letter-spacing: 0.77px;
  color: #000000;
  text-align: center;
  padding: 1px 12px;
  padding-top: 2px;
  display: block;
  float: right;
  i {
    font-size: 8px;
    position: relative;
    top: 0px;
    margin-right: 4px;
  }
  &:hover {
    border-color: #c1ff28;
    background-color: #c1ff28;
  }
}
.btn-save-table,
.btn-close-table,
.btn-edit-table {
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 20px;
  padding: 0px;
  text-align: center;
  border: 0px;
  background-color: transparent;
  font-size: 16px;
  color: $color-jungle-green;
  margin-left: 7px;
  i {
    &:before {
      color: $color-jungle-green;
    }
  }
}

.form-group-detail {
  .group-detail-form-group {
    .group-detail-form-label {
      width: 100%;
      color: $color-grey-dusty;
      float: left;
      font-weight: normal;
      font-family: $mulish-regular;
      margin-bottom: 0px;
      margin-top: 10px;
    }
    .group-detail-form-label-1 {
      width: 100%;
      margin-bottom: 30px;
      margin-top: 10px;
      line-height: 25px;
      text-align: center;
      font-size: 20px;
      color: rgb(42, 47, 50);
      font-size: 16px;
      font-weight: 600;
    }

    .group-detail-form-value {
      width: 100%;
      padding: 8px 16px;
      border: 1px solid #dee3eb;
      height: 35px;
      line-height: 35px;
      border-radius: 3px;
      font-family: $mulish-regular;
      // font-weight: 600;
      &:focus {
        border-color: $color-jungle-green;
      }
    }
    #input-airdrop-title {
      &.error-modal {
        border: solid 1px $color-red-main;
        border-radius: 3px;
      }
    }
    .textarea_input {
      height: 120px;
    }
  }
  .error-box {
    display: block;
    float: left;
    overflow: hidden;
    width: 100%;
    span {
      font-family: $mulish-regular !important;
    }
  }
  .is-error {
    color: #ff5252 !important;
  }
}

.filter_container {
  margin: 10px 0px 25px 0px;
  .title_item {
    color: $color_mine_shaft;
    font-size: $font_big;
    font-family: $mulish-regular;
  }
  .select-market {
    font-family: $mulish-regular;
    color: $color-grey-dark;
    font-size: $font-small;
    float: left;
  }
  .search_box {
    display: inline-block;
    float: right;
    width: 215px;
    max-width: 100%;
    .search_input {
      background-color: transparent;
      height: 28px;
      border: 1px solid $color_alto;
      padding: 4px 15px;
      line-height: 20px;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: $font-small;
    }
  }
}

.table_UserSetting_right {
  background-color: $color_white;
  margin: 0;

  thead {
    font-size: $font-small;
    th {
      position: relative;
      background-color: $color_white;
      line-height: 15px;
      font-weight: 500;
      color: $color_grey;
      padding: 5px 25px 4px 15px !important;
      border-bottom: 1px solid $color_alto;
      height: 38px;
      display: table-cell;
      vertical-align: inherit;
      font-family: $mulish-regular;
    }
  }
  tbody {
    tr {
      vertical-align: top;
      overflow-y: hidden;
      transition-property: height;
      transition-duration: 0.3s, 0.3s;
      transition-timing-function: ease, ease-in;
      height: auto;
      background-color: $color_white;
      &:last-child {
        td {
          .item_email_setting {
            vertical-align: middle;
            .tooltip_address_setting {
              top: inherit;
              bottom: 100%;
              &::after {
                top: inherit;
                bottom: -10px;
                border-top-color: $color_white;
                border-bottom-color: transparent;
              }
            }
          }
        }
      }

      td {
        height: 40px;
        overflow: initial;
        line-height: 23px;
        font-size: 14px !important;
        font-weight: 500;
        color: $color_mine_shaft;
        // padding: 8px 15px 4px 15px;
        border-top: 1px solid $color_catskill_white;
        font-family: $mulish-regular;
        vertical-align: middle;
        padding: 4px 8px;
      }
    }
  }
}
.text-bold-coin {
  // text-overflow: ellipsis;
  white-space: nowrap;
  width: 53px;
  overflow: hidden;
}
.text-bold-address {
  text-overflow: ellipsis;
  width: 320px;
  overflow: hidden;
  vertical-align: middle;
}
.text-bold-balance {
  text-overflow: ellipsis;
  width: 83px;
  overflow: hidden;
}
.text-bold-available-balance {
  text-overflow: ellipsis;
  max-width: 340px;
  overflow: hidden;
}
.market-select-area {
  padding-left: 0;
  .select-market-text {
    margin-right: 20px;
    color: #333333;
    font-size: 18px;
    font-family: "Mulish-Medium", sans-serif;
    line-height: 28px;
    float: left;
  }
}

.col-left-user {
  min-width: 330px;
}
.col-right-user {
  max-width: calc(100% - 330px);
}
</style>

<style lang="scss">
@import "@/assets/sass/variables";
#user_trading_settings {
  .customModal {
    height: auto;
    .modal-content {
      height: auto;
      .modal-body {
        padding: 0px 30px 15px 30px;
        .group-detail-form-label {
          margin-bottom: 5px;
        }
      }
      .modal-footer {
        padding-bottom: 30px;
      }
    }
  }
  .sc_search_select {
    .group_search_select {
      .button_drop_search {
        width: 80px;
        height: 30px !important;
        padding: 5px 10px 5px 10px !important;
        border-radius: 3px;
        // margin-right: 20px;
        font-size: $font-small;
        font-family: $mulish-regular;
        color: $color-grey-dark;
        i.icon-arrow1 {
          margin-left: 5px;
          color: $color_grey;
        }
        &:hover {
          border-color: $color-jungle-green;
          i.icon-arrow1 {
            color: $color-jungle-green;
          }
        }
      }
      .box_list_search_select {
        .list_search_select {
          li {
            font-family: $mulish-regular;
            font-size: $font-small;
            &:hover,
            &:active,
            &:focus {
              color: $color-jungle-green;
            }
          }
        }
      }
    }
  }

  tr:hover {
    background-color: #ececec;
  }
  .box_table_UserSetting_right {
    tr:hover {
      cursor: pointer;
    }
  }
  .box_UserSetting_right {
    table {
      tbody {
        td {
          cursor: default;
        }
      }
    }
    tr {
      &.empty-data {
        &:hover {
          background-color: transparent;
          cursor: default;
        }
        border-bottom: 1px solid transparent;
      }
      &.active {
        td {
          background-color: #d6efe9;
          border-top: 1px solid #d6efe9;
        }
        position: relative;
        &:after {
          display: none;
        }
      }
    }
  }
  table {
    th {
      padding: 5px 10px 4px 15px !important;
    }
    tbody {
      td {
        padding: 5px 10px 4px 15px;
        .text-bold-coin {
          width: 30px;
        }
      }
    }
  }
  .common-btn-item,
  .btn-close-table {
    cursor: pointer;
  }
}
</style>
